module.exports = __webpack_public_path__ + "static/img/apply@2x.8c62561f.png";